function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { paragraphGet } from '../../../redux/actions/Entity/Paragraph';
import EntityMapperContext from '../../../Context/EntityMapperContext';
import ContextualActionsButtons from '../../../Components/ContextualActions/Buttons';
var Paragraph = /*#__PURE__*/function (_Component) {
  _inherits(Paragraph, _Component);
  var _super = _createSuper(Paragraph);
  function Paragraph() {
    _classCallCheck(this, Paragraph);
    return _super.apply(this, arguments);
  }
  _createClass(Paragraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        entity = _this$props.entity,
        viewMode = _this$props.viewMode,
        id = _this$props.id,
        dispatch = _this$props.dispatch,
        currentLanguage = _this$props.currentLanguage;
      if (id && (!entity || entity.getIn(['langcode', 0, 'value']) !== currentLanguage)) {
        dispatch(paragraphGet(id, viewMode));
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
        viewMode = _this$props2.viewMode,
        id = _this$props2.id,
        dispatch = _this$props2.dispatch,
        currentLanguage = _this$props2.currentLanguage;
      if (id && (id !== prevProps.id || currentLanguage !== prevProps.currentLanguage)) {
        dispatch(paragraphGet(id, viewMode));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        entity = _this$props3.entity;
      if (!entity) {
        return null;
      }
      var paragraphType = entity.getIn(['type', 0, 'target_id']);
      return /*#__PURE__*/React.createElement(EntityMapperContext.Consumer, null, function (entityTypesMapper) {
        var paragraphMappers = entityTypesMapper.paragraph;
        var ParagraphComponent = paragraphMappers[paragraphType];
        if (ParagraphComponent) {
          return /*#__PURE__*/React.createElement(ContextualActionsButtons, {
            entityType: "paragraph",
            entity: entity
          }, /*#__PURE__*/React.createElement(ParagraphComponent, _extends({
            id: entity.getIn(['id', 0, 'value'])
          }, _this.props)));
        }
        return /*#__PURE__*/React.createElement("div", null, entity.getIn(['type', 0, 'target_id']));
      });
    }
  }]);
  return Paragraph;
}(Component);
function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    entity: ownProps.entity || state.getIn(['paragraph', ownProps.id]),
    currentLanguage: state.getIn(['ui', 'language'])
  };
}
export default connect(mapStateToProps)(Paragraph);